export function DocumentIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M4.66671 14H11.3334C12.0698 14 12.6667 13.403 12.6667 12.6667V6.27614C12.6667 6.09933 12.5965 5.92976 12.4714 5.80474L8.86197 2.19526C8.73695 2.07024 8.56738 2 8.39057 2H4.66671C3.93033 2 3.33337 2.59695 3.33337 3.33333V12.6667C3.33337 13.403 3.93033 14 4.66671 14Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
